import swedish from './locales/sv-SE.json';
import norwegian from './locales/nb-NO.json';
import english from './locales/en.json';

export default {
  'sv-SE': swedish,
  'nb-NO': norwegian,
  'en': english
};
